<template>
  <NewStudioModalsModalShell :title="title" @close="close">
    <template v-if="type === ModalType.MyTiles">
      <div class="tiles"><article v-for="tile in tiles" :key="tile.variant_id"><img :src="tile.photo_url" alt=""><span>{{ tile.color_label }} · {{ tile.shape_label }}</span><b>×{{ tile.quantity }}</b></article></div>
      <button class="primary" type="button" @click="addToCart">Add to Cart</button>
    </template>
    <template v-else-if="type === ModalType.AttachmentOption">
      <div class="choices"><button type="button" @click="chooseAttachment('adhesive')">Permanent Adhesive Strip</button><button type="button" @click="chooseAttachment('screws')">Drywall Screws</button></div>
    </template>
    <template v-else-if="type === ModalType.ColorRemap">
      <p>Some colors in your design have been discontinued and replaced:</p>
      <ul><li v-for="entry in remappedColors" :key="`${entry.from}-${entry.to}`">{{ entry.from }} → <strong>{{ entry.to }}</strong></li></ul>
      <button class="primary" type="button" @click="close">Got It</button>
    </template>
    <template v-else>
      <div class="choices"><button type="button" @click="switchTo(ModalType.New)">New Design</button><button type="button" @click="switchTo(ModalType.Load)">Load Design</button><button type="button" @click="switchTo(ModalType.MyDesigns)">Your Designs</button></div>
    </template>
  </NewStudioModalsModalShell>
</template>

<script setup lang="ts">
import { ModalType } from '~/stores/modal'
const props = defineProps<{ type: ModalType }>()
const gridStore = useGridStore()
const projectStore = useProjectStore()
const modalStore = useModalStore()
const titles: Partial<Record<ModalType, string>> = { [ModalType.MyTiles]: 'My Tiles', [ModalType.AttachmentOption]: 'Choose Your Attachment Method', [ModalType.ColorRemap]: 'Colors Updated', [ModalType.File]: 'Project Files' }
const title = computed(() => titles[props.type] || 'Studio')
const tiles = computed(() => gridStore.getTilesList())
const remappedColors = computed(() => modalStore.getModalOptions(ModalType.ColorRemap)?.remappedColors || [])
const close = () => modalStore.toggleModal(props.type)
const addToCart = async () => { await projectStore.addToCart(); close() }
const chooseAttachment = (choice: string) => { modalStore.getModalCallback(ModalType.AttachmentOption)?.(choice); close() }
const switchTo = (type: ModalType) => { close(); modalStore.toggleModal(type) }
</script>

<style scoped>
.primary { width: 100%; min-height: 50px; margin-top: 18px; border: 0; background: #2e3b48; color: #fff; font: inherit; font-weight: 700; }
.tiles { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
.tiles article { display: grid; gap: 4px; padding: 9px; border: 1px solid #deddd9; font-size: 12px; }
.tiles img { width: 100%; aspect-ratio: 1; object-fit: contain; }
.choices { display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; }
.choices button { min-height: 110px; border: 2px solid #deddd9; background: #f8f7f4; font: inherit; font-weight: 700; cursor: pointer; }
</style>
